import { memoize } from "lodash";
import { insertDirective } from "./chordProMunge";
import { durationToSeconds, parseChordProString } from "./chordProParse";
import type { Song, SongId, UserId } from "./types";

export const formDirectives = [
  "title",
  "artist",
  "capo",
  "duration",
  "x_audio_recorder",
];

// const stripDirectives = (chordPro: string) => {
//   formDirectives.forEach((directive) => {
//     chordPro = stripDirective(directive, chordPro);
//   });
//   return chordPro;
// };

export default function chordProToSong({
  chordPro,
  id,
  userId,
}: {
  chordPro: string;
  id: SongId;
  userId: UserId;
}): Song {
  const p = parseChordProString(chordPro);
  const ts = Date.now();
  const song: Song = {
    id,
    title: p.title || "",
    artist: p.artist || "",
    capo: p.capo || 0,
    key: p.key || "",
    chordPro,
    audioFileUrl:
      typeof p.x_audio_recorder === "object" && p.x_audio_recorder
        ? (p.x_audio_recorder as { url?: string }).url || null
        : null,
    duration: durationToSeconds(p.duration || "") || 0,
    created_timestamp: ts,
    updated_timestamp: ts,
    deleted_timestamp: 0,
    created_by_user_id: userId,
    updated_by_user_id: userId,
  };
  return song;
}

export const songToChordPro = memoize((song: Song) => {
  let chordPro = song.chordPro;
  for (const directive of formDirectives.reverse()) {
    if (directive === "x_audio_recorder" && song.audioFileUrl) {
      chordPro = insertDirective(
        directive,
        `url="${song.audioFileUrl}"`,
        chordPro,
      );
    } else {
      // @ts-ignore
      chordPro = insertDirective(directive, song[directive], chordPro);
    }
  }
  return chordPro;
});
